import {zDateTime} from '@brunata-angular/util';
import {z} from 'zod';
export const apiTokenSchema = z.object({
    apiTokenId: z.number(),
    tokenPartial: z.string(),
    createDate: zDateTime,
    tokenName: z.string(),
});
export type ApiToken = z.infer<typeof apiTokenSchema>;

export const createApiTokenSchema = z.object({
    apiTokenId: z.number(),
    token: z.string(),
    createDate: zDateTime,
    tokenName: z.string(),
});
export type CreateApiToken = z.infer<typeof createApiTokenSchema>;
